<template>
	<div class="live-schedule1" :class="[showChooseTime || showQrcode || showPicker ? 'max-page-height' : '']">
		<van-empty description="内容正在完善中..." v-if="isempty" />
		<div v-else>
			<!-- <div class="timeTabs-wrap" v-if="scheduleDate.length!=0">
				<div class="timeTabs" v-if="color">
					<div class="tab-item" v-for="(item,index) in scheduleDate" :key="index" @click="switchDate(item)" :class="item==active?'active':''" :style="{background:(item==active?color:'')}">
						{{item}}
					</div>
				</div>
				<div class="timeTabs" v-else>
					<div class="tab-item" v-for="(item,index) in scheduleDate" :key="index" @click="switchDate(item)" :class="item==active?'active':''">
						{{item}}
					</div>
				</div>			
			</div> -->
			<div class="content" ref="view">
				<div v-for="(item, suffix) in scheduleList" :key="suffix">
					<div v-for="(value, index) in item" :key="index">
						<div class="scheduleHead">
							<div class="name-time">
								<div class="left-flex" style="width:100%;" :id="'time_' + index">
									<h3 v-if="value.name">
										<span v-if="path == '/vascularNews/expert/detail'">{{ suffix }}</span>
										{{ value.name }}
									</h3>
									<div class="logo" v-if="value.image">
										<img :src="value.image" alt="" v-if="value.image" />
									</div>
									<div class="expert">
										<span class="time2">{{ value.start_at_s + ' - ' + value.end_at_s }}</span>
									</div>
									<!-- <img src="@/assets/images/cec2022/subscribe_schedule.png"
										style="width:60px;margin-top:5px;" @click.stop="subscribe(value, 0)"
										v-if="value.is_preview == 0 && value.allow_preview == 1">
									<img src="@/assets/images/cec2022/has_subscribe.png"
										style="width:60px;margin-top:5px;" @click.stop="cancelSubscribe(value, 0)"
										v-else-if="value.allow_preview == 1"> -->
								</div>
								<!-- <div class="right-flex">
									<img :src="value.image" alt="" v-if="value.image"/>
								</div> -->
							</div>
							<div class="attendee">
								<!-- <div class="expert">
									<span>{{value.start_at+' - '+ value.end_at}}</span>
								</div> -->
								<div class="chairman expert" v-if="value.chairman_writers.length > 0">
									<div class="flexRow-center">
										<!-- <img src="@/assets/images/System/chairman.png" alt=""> -->
										<span class="host_t">主&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;席:</span>
									</div>
									<div class="names">
										<p>
											<router-link
												:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: val.id } }"
												v-for="val in value.chairman_writers" :key="val.id">
												<p class="one-line"><img class="avatar" v-if="val.photo" :src="val.photo" alt="">{{ val.name }}<span
														v-if="val.company && meeting_id != 581">({{
															val.company }})</span></p>
											</router-link>
										</p>
									</div>
								</div>
								<div class="host expert" v-if="value.host_writers.length > 0">
									<div class="flexRow-center">
										<!-- <img src="@/assets/images/System/host_expert.png" alt=""> -->
										<span class="host_t">主持专家: </span>
									</div>
									<div class="names">
										<p>
											<router-link
												:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: val.id } }"
												v-for="val in value.host_writers" :key="val.id">
												<p class="one-line"><img class="avatar" v-if="val.photo" :src="val.photo" alt="">{{ val.name }}<span
														v-if="val.company && meeting_id != 581">({{
															val.company }})</span></p>
											</router-link>
										</p>
									</div>
								</div>
								<div class="discussors expert " v-if="value.discussor_writers.length > 0">
									<div>
										<!-- <img src="@/assets/images/System/chat_expert.png" alt=""> -->
										<span class="text-top host_t">讨论专家:</span>
									</div>
									<div class="names">
										<p>
											<router-link
												:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: val.id } }"
												v-for="val in value.discussor_writers" :key="val.id">
												<p class="one-line"><img class="avatar" v-if="val.photo" :src="val.photo" alt="">{{ val.name }}<span
														v-if="val.company && meeting_id != 581">({{
															val.company }})</span></p>
											</router-link>

										</p>
									</div>
								</div>
								<div>
									<div class="discussors expert" v-for="(val) in value.titles" :key="val.id">
										<div class="flexRow-center">
											<!-- <img src="@/assets/images/disscuss.jpg" alt=""> -->
											<span class="host_t">{{ val.title }}:</span>
										</div>
										<div class="names">
											<p>
												<router-link
													:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: item.id } }"
													v-for="item in val.writers" :key="item.id">
													<p class="one-line"><img class="avatar" v-if="item.photo" :src="item.photo" alt="">{{ item.name }}<span
															v-if="item.company && meeting_id != 581">({{
																item.company }})</span></p>
												</router-link>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="chapters">
							<div class="time-item" v-for="(val, ind) in value.details" :key="ind"
								:id="'chapter_' + val.id"
								:class="{ 'norecord': !val.recordid || !meetingInfo.lookback_status, 'recorded': val.recordid && meetingInfo.lookback_status, 'change': currentRecordid && (val.recordid == currentRecordid), 'playing': isWithinTimeRange(val.start_at, val.end_at) == 2 || time_id == 'chapter_' + item.id, 'nostart': isWithinTimeRange(val.start_at, val.end_at) == 1 }">
								<!-- <div class="time-item" v-for="(val, ind) in value.details" :key="ind"
								:class="{ 'norecord': !val.recordid, 'recorded': val.recordid, 'playing': currentRecordid && (val.recordid == currentRecordid), 'nostart': isWithinTimeRange(val.start_at, val.end_at) == 1 }"> -->
								<div class="time-item-top">
									<div class="time">
										<!-- <van-icon name="clock-o" /> -->
										<span>{{ val.time }}</span>
									</div>
									<div class="introduction">
										<div style="display: flex;justify-content: space-between;">
											<!-- <div style="flex: 1;"> -->
											<p class="title">{{ val.name }}</p>

											<!-- @click.stop="cancelSubscribe(val, 1)" -->
											<!-- <p class="nopreview">
													订阅
												</p> -->
											<!-- 添加微信服务号订阅通知按钮 -->
											<div v-if="val.is_preview == 0 && val.allow_preview == 1 && isWxBtn"
												class="nopreview">
												{{ val.preview_count ? val.preview_count + '人' : '' }}订阅
												<wx-open-subscribe
													template="0pevoMHKwlm1V7N2uUl6ucg-_swEPoKeg_JUmQrHVsE"
													@success="subscribeSuccess" @error="subscribeFail" :data-id="val.id"
													:data-preview="val.is_preview" :data-type="1" ref="subscribeBtn"
													class="launch-btn">
													<script type="text/wxtag-template" slot="style">
														<style>
														.subscribe-btn {
															position:absolute;
															top:0;
															left:0;
															opacity: 0;
															width:100%;
															height:100%;
														}
														</style>
													</script>
													<script type="text/wxtag-template">
														<button class="subscribe-btn"></button>
													</script>
												</wx-open-subscribe>
											</div>

											<p class="previewed"
												v-else-if="val.allow_preview == 1 && val.is_preview == 1"
												@click.stop="cancelSubscribe(val, 1)">
												已订阅
											</p>

											<p class="nopreview"
												v-else-if="meetingInfo.extent_info.want_look_status == 1 && !val.is_want_look"
												@click.stop="wantLook(val)">
												{{ val.want_look_count ? val.want_look_count + '人' : '' }}想看
											</p>
											<p class="redbtn"
												v-else-if="meetingInfo.extent_info.want_look_status == 1 && val.is_want_look"
												@click.stop="wantLook(val)">
												已想看
											</p>
											<!-- </div> -->

										</div>

										<router-link
											:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: i.id } }"
											v-for="i in val.writers" :key="i.id">
											<!-- <p class="name" v-for="i in val.writers" :key="i.id"> -->

											<p :style="{ 'margin-bottom': i.company ? '5px' : '0px' }" class="name"
												style="margin-bottom: 5px;
											white-space: nowrap;
											overflow: hidden;
											text-overflow: ellipsis;
											display: block;
											">
												<span class="dot"></span><img class="avatar" v-if="i.photo" :src="i.photo" alt="">{{ i.name }}<span
													v-if="i.company && meeting_id != 581">({{
														i.company
													}})</span>
											</p>
											<!-- </p> -->
										</router-link>

										<p class="des" v-if="val.des">详情: {{ val.des }}</p>

										<div class="status">
											<div class="s_cell" v-if="isWithinTimeRange(val.start_at, val.end_at) == 1">
												<p style="color: #999;">未开始 <van-icon name="clock-o" /></p>

											</div>
											<div class="s_cell"
												v-else-if="isWithinTimeRange(val.start_at, val.end_at) == 2">
												<p>进行中</p>
												<div class="icon_wrap">
													<img src="../../../../assets/images/icon_playing.png"
														@click="playLive()">
												</div>
											</div>
											<div class="s_cell"
												v-else-if="!val.recordid || !meetingInfo.lookback_status">
												<p style="color: #999;">{{ meeting_id != 522 ? "因版权原因，不设直播录播" : "暂无录播"
												}} </p>
											</div>

											<!-- <img src="../../../../assets/images/Meeting/norecord.jpg" v-if="!val.recordid"
										@click="playRecorded(index, ind, value.session.id, val)"> -->


											<div class="s_cell" v-else>
												<p style="flex: 1;">已生成录播</p>
												<div class="flex"
													style="margin-right: 12px;color: #999;font-size: 13px;align-items: center;gap: 5px;">
													<img style="width: 15px;height: 10px;margin-top: 1px;"
														src="../../../../assets/images/icon_see.png" alt="">
													<p style="color: #666;">{{ val.video_play_click_count }}</p>
												</div>
												<div class="icon_wrap">

													<img src="../../../../assets/images/icon_play.png"
														@click="playRecorded(index, ind, value.session.id, val)">
												</div>
											</div>


											<!-- <div class="icon_wrap" v-if="val.is_preview == 0 && val.allow_preview == 1">
											<img src="@/assets/images/cec2022/subscribe_schedule.png"
												style="width:70%;margin-top:5px;" @click.stop="subscribe(val, 1)">
										</div>
										<div class="icon_wrap" v-else-if="val.allow_preview == 1">
											<img src="@/assets/images/cec2022/has_subscribe.png"
												style="width:70%;margin-top:5px;" @click.stop="cancelSubscribe(val, 1)">
										</div> -->
										</div>
									</div>

								</div>


								<div class="wiki-info"
									v-if="val.wiki_article_info && val.wiki_article_info.id && isWxBtn">
									<img src="@/assets/images/Meeting/wiki_logo.jpeg">

									<div>
										<p style="display: flex;align-items: center;">点击阅读<img
												style="width:18px;margin: 0 4px;"
												src="@/assets/images/Meeting/icon_wechatsmall.png" alt="">Med Wik</p>
										<div class="wiki-news"
											style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;width: 100%;">
											{{ val.wiki_article_info.title }}</div>
									</div>
									<wx-open-launch-weapp class="launch-btn" username="gh_4931ece2a2ce"
										appid="wxaa0bdd5050768d0e"
										:path="'pages/pagesA/newsDetail/newsDetail?id=' + val.wiki_article_info.id">
										<script type="text/wxtag-template">
											<style>.mini-btn {
											width:100%;
											height: 100%;
											position:absolute;
											opacity: 0}</style> 
											<p class="mini-btn"></p>
          								</script>
									</wx-open-launch-weapp>

								</div>

							</div>
						</div>

					</div>
				</div>
			</div>
		</div>

		<van-popup v-model="showQrcode" round>
			<div style="margin-top:10px;">
				<h2>我们将通过服务号提醒您观看直播</h2>
				<img src="@/assets/images/cec2022/qrcode.jpg" style="width:100px;">
				<h2 class="yellowbd">STEP1.请长按二维码关注服务号</h2>
			</div>
			<h2 class="yellowbd" style="margin-bottom:10px;">STEP2.点击订阅按钮设置会议提醒</h2>
		</van-popup>
		<van-popup v-model="showChooseTime" round>
			<div style="margin-top:20px;">
				<h2>请选择在本场会议正式开始前</h2>
				<van-field readonly clickable name="picker" :value="pre_time" placeholder="点击选择时间"
					right-icon="arrow-down" @click="showPicker = true"
					style="width:100px;display: inline-block;vertical-align: bottom;border: 1px solid #DCDFE6;border-radius:5px;" />
				<span style="font-size:20px;line-height:46px;">分钟</span>
				<h2 style="margin-top:10px;">通过服务号消息提醒您观看直播</h2>
				<button @click.stop="submitSubscribe">确定</button>
			</div>

		</van-popup>
		<van-popup v-model="showPicker" position="bottom" :style="{ height: '300px' }">
			<van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false"
				title="请选择时间" />
		</van-popup>

	</div>
</template>
<script>
import { Toast } from 'vant'
import { isSubscribe, previewLive, cancelPreviewLive, WxShare, wantLookLive, RecordPlayUrl } from "../../../../config/interface.js";
import smoothscroll from 'smoothscroll-polyfill';
import wx from 'weixin-js-sdk'
import { set } from 'nprogress';
export default {
	props: ['meetingSchedule', 'color', 'meetingInfo', 'isWxBtn'],
	data() {
		return {
			isempty: false,
			meeting_id: 0,
			scheduleData: this.meetingSchedule,       //日程
			scheduleDate: Object.keys(this.meetingSchedule),   //日期
			scheduleList: [],       //日期对应的日程列表
			active: 0,
			scrollTop: 0,           //滚动距离
			selectedRecorded: this.$store.state.selectedRecorded,
			path: '',
			live_url: this.$store.state.videoUrl,
			currentRecordid: this.$store.state.videoUrl,
			is_subscribe: 0,
			showQrcode: false,
			showChooseTime: false,
			showPicker: false,
			options: [
				{
					value: 5,
					label: '5分钟'
				},
				{
					value: 15,
					label: '15分钟'
				},
				{
					value: 30,
					label: '30分钟'
				}
			],
			columns: [5, 15, 30],
			pre_time: 5,
			subscribe_item: {},
			subscribe_type: 0,
			time_id: null,
			time_id2: null,
			timer: null,
			showWantLookTip: false
			// isWxBtn: false,
		}
	},
	watch: {
		//监测meetingSchedule
		meetingSchedule(newData, oldData) {
			this.scheduleData = newData;
			this.isempty = !Object.keys(newData).length;
			this.scheduleDate = Object.keys(newData);
			this.switchDate(this.scheduleDate[0]);

		},
		'$store.state.videoUrl'(newData) {
			this.currentRecordid = newData
		},
		// "time_id2"(newData) {
		// console.log("会议未开始", newData);
		// setTimeout(() => {
		// 	smoothscroll.polyfill();
		// 	console.log(newData, document.getElementById(newData))
		// 	let el = document.getElementById(newData)
		// 	if (el) {
		// 		el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
		// 	}
		// }, 1000)
		// },
		"time_id"(newData) {
			console.log("会议进行中", newData);
			setTimeout(() => {
				smoothscroll.polyfill();
				let el = document.getElementById(newData)
				if (el) {
					el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
				}
			}, 1000)
		}

	},
	// created() {
	// 	this.checkIOSAndReload()
	// },
	mounted() {

		// window.addEventListener('scroll', this.handleScroll);
		let url = this.$route.query.video_url ? this.$route.query.video_url : '';
		this.path = this.$route.path;
		this.meeting_id = this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id;
		this.getSubscribeState();
	},

	beforeDestroy() {
		if (this.timer) {
			console.log(this.timer)
			clearInterval(this.timer)
		}



	},
	// 局部忽略元素
	ignoreElements: ['wx-open-subscribe'],
	methods: {

		// 判断是否是 iOS 设备并刷新页面
		checkIOSAndReload() {
			const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
			if (isIOS && !sessionStorage.getItem('isReloaded')) {
				sessionStorage.setItem('isReloaded', 'true');
				// window.location.reload();
				this.$nextTick(() => {
					this.getWxConfig()
				})
			}
		},		//切换日期
		switchDate(date) {
			if (!date) {
				return;
			}
			//  console.log('scheduleDate1',this.scheduleDate)
			this.active = date;
			this.scheduleList = this.scheduleData[date];
			let key = Object.keys(this.scheduleList)[0];
			let scheduleList = this.scheduleList[key];

			for (var i = 0; i < scheduleList.length; i++) {
				let data = scheduleList[i]
				let startTime = (data['start_at'].split(' ')[1]).split(':');
				data.start_at_s = startTime[0] + ':' + startTime[1];//获取具体时间重设格式
				let endTime = (data['end_at'].split(' ')[1]).split(':');
				data.end_at_s = endTime[0] + ':' + endTime[1];;//获取具体时间重设格式
				this.initChapterTimeRang(data)

			}

			// this.scheduleList = this.scheduleList;
			this.$store.dispatch('receiveRecording', this.scheduleList)
		},
		initChapterTimeRang(data) {
			let that = this
			data['details'].forEach((item, index) => {
				let init_startDate = item['start_at'];//初始开始日期时间
				let init_endDate = item['end_at'];//初始结束日期时间
				let startTime2 = (item['start_at'].split(' ')[1]).split(':');
				startTime2 = startTime2[0] + ':' + startTime2[1];
				let endTime2 = (item['end_at'].split(' ')[1]).split(':');
				endTime2 = endTime2[0] + ':' + endTime2[1];
				const now = new Date();
				const date = now.getFullYear() + '/' + parseInt(now.getMonth() + 1) + '/' + now.getDate();
				if (that.isWithinTimeRange(init_startDate, init_endDate) == 1) {
					let newStartTime = date + ' ' + startTime2;
					let newEndTime = date + ' ' + endTime2;
					if (that.isTimeBetween(newStartTime, newEndTime)) {
						// console.log("会议未开始"));
						that.time_id2 = 'chapter_' + item.id
						if (!that.timer) {
							that.timer = setInterval(() => {
								console.log('refresh')
								that.initChapterTimeRang(data)
							}, 10000)
						}
						return;
					}


				} else if (this.isWithinTimeRange(init_startDate, init_endDate) == 3) {
					// console.log("会议已结束");
					this.time_id = null;
					this.time_id2 = null

				} else if (this.isWithinTimeRange(init_startDate, init_endDate) == 2) {
					if (this.time_id == 'chapter_' + item.id) {
						return;
					}
					// console.log("当前日期在会议时间段内", 'chapter_' + item.id);
					this.time_id = 'chapter_' + item.id
					if (!that.timer) {
						that.timer = setInterval(() => {
							console.log('refresh')
							that.initChapterTimeRang(data)
						}, 10000)
					}

				}


			})
		},
		//打开medwiki小程序文章页
		getWxConfig() {
			let that = this
			if (common.is_weixin()) {
				const url = WxShare;
				let params = {
					"jssdk": ["wx-open-launch-weapp"],
					"url": location.href
				};
				const method = 'POST';
				fetch(url, params, method)
					.then((res) => {
						if (res.code == 0) {
							wx.config({
								debug: false, // 验证结果弹窗控制，微信环境可能会因为接口安全问题出现失败弹窗，所以直接设置的false，
								appId: res.data.appId, // 公众号唯一appid
								nonceStr: res.data.nonceStr,
								timestamp: res.data.timestamp,
								signature: res.data.signature,
								jsApiList: res.data.jsApiList,//随便填写的一个
								openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
							})
							wx.ready(function (success) {
								that.isWxBtn = true //表示验证成功
								console.log('success', success)
							})
							wx.error(function (err) {
								Toast.fail('暂不支持', err);
								// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
								console.log('error', err)
							})


						}
					})

			}
		},
		//判断是否在当前时间段内
		isWithinTimeRange(startTime, endTime) {
			let flag = 0
			var now = new Date();
			// 获取起始日期和结束日期
			let currentDate = new Date();
			let startDate = new Date(startTime.split(' ')[0])
			let endDate = new Date(endTime.split(' ')[0]);

			// 判断当前日期是否在某个时间段
			var [startHour, startMinute] = startTime.split(' ')[1].split(':');
			var [endHour, endMinute] = endTime.split(' ')[1].split(':');

			startDate.setHours(startHour, startMinute, 0, 0);
			endDate.setHours(endHour, endMinute, 0, 0);
			if (now < startDate) { //未开始
				flag = 1
			} else if (now >= startDate && now <= endDate) {//进行中
				flag = 2
			} else { //已结束
				flag = 3
			}
			return flag;


		},

		isTimeBetween(start, end, now) {
			// 如果未提供 now，则使用当前时间
			now = now || new Date();

			// 创建开始和结束时间的日期对象
			var startTime = new Date(start).setSeconds(0, 0); // 清零秒和毫秒
			var endTime = new Date(end).setSeconds(0, 0); // 清零秒和毫秒
			var nowTime = now.setSeconds(0, 0); // 清零秒和毫秒
			// console.log(startTime, endTime, nowTime)
			// 判断 nowTime 是否在 startTime 和 endTime 之间
			return nowTime >= startTime && nowTime <= endTime;
		},

		//浏览器滚动
		handleScroll() {
			this.scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
				document.body.scrollTop;
			if (this.scrollTop > 60) {
				// console.log(1212)
			}
		},
		//播放录播
		playRecorded(suffix, index, id, value) {
			console.log(this.meetingInfo)
			if (this.meetingInfo.lookback_pay_status == 1 && this.meetingInfo.user_pay_status == 0) {
				this.$emit('showChargePopup')
				return;
			}
			if (value.recordid) {
				this.$store.dispatch('receiveVideoUrl', value.recordid);
				//判断当前的路由
				let path = this.$route.path;
				if (path == '/meeting/schedule') {
					this.$router.push({
						path: '/meeting/live',
						query: {
							meeting_id: this.$route.query.id,
							id: id,
							video_url: value.recordid
						}
					})

				}
			} else {
				common.toast('暂无录播', 1000)
			}
			this.RecordPlayData(value.id)
			this.$emit('refreshVideoZimu', value.id)

		},
		//点击会议录播视频播放记录
		RecordPlayData(id) {
			const url = RecordPlayUrl;
			let params = {
				type_name: 'meeting_recorded_video_play',
				id: id
			};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						console.log('数据更新成功')

					}
				})
		},
		//直播
		playLive() {
			this.$store.dispatch('receiveVideoUrl', '');
			this.$emit('getLiveInfo')
			// this.$store.dispatch('receiveVideoUrl', this.live_url);

		},
		// 其他方法
		handleSubscribe(id) {
			this.scheduleList = this.scheduleData[this.active];
			let key = Object.keys(this.scheduleList)[0];
			console.log('scheduleList', this.scheduleList, key)
			let scheduleList = this.scheduleList[key];
			for (var l = 0; l < scheduleList.length; l++) {
				for (let i = 0; i < scheduleList[l].details.length; i++) {
					if (scheduleList[l].details[i].id == id) {
						this.scheduleList[key][l]['details'][i]['is_preview'] = 1;
						// this.scheduleList[key][l]['details'][i]['preview_count']++;
						console.log(scheduleList[l].details[i].id)
					}
				}
			}
		},
		getSubscribeState() {
			const url = isSubscribe;
			let params = {};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						this.is_subscribe = res.data.subscribe
					}
				})
		},
		//想看
		wantLook(item) {
			const url = wantLookLive;
			let params = {
				meeting_id: this.$route.query.meeting_id,
				type: 1,
				id: item.id
			};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						if (item.is_want_look == 1) {
							item.is_want_look = 0
							// item.want_look_count--
							// console.log('想看', item.is_want_look)


						} else {
							item.is_want_look = 1
							// item.want_look_count++
							// console.log('想看', item.is_want_look)
							this.$emit('showWantLook')

						}
						// Toast('您想看的内容后续会在Med Wiki发布! 敬请关注~')

					}
				})
		},
		subscribe(item, type) {
			item.is_preview = 1;

			// this.subscribe_item = item;
			// this.subscribe_type = type
			// if (this.is_subscribe == 1) {
			// 	// this.showChooseTime = true;
			// 	// this.$emit('subscribeTime', 1)
			// }
			// else {
			// 	Toast.loading({
			// 		duration: 0,
			// 		forbidClick: true,
			// 		message: '',
			// 	});
			// 	const url = isSubscribe;
			// 	let params = {};
			// 	const method = 'POST';
			// 	fetch(url, params, method)
			// 		.then((res) => {
			// 			Toast.clear();
			// 			if (res.code == 0) {
			// 				if (res.data.subscribe == 0) {
			// 					this.showQrcode = true
			// 				}
			// 				else {
			// 					this.is_subscribe = res.data.subscribe
			// 					// this.showChooseTime = true;
			// 					// this.$emit('subscribeTime', 1)



			// 				}
			// 			}
			// 		})
			// }

		},
		subscribeSuccess(e) {
			// 直接打印e.detail就可以看到返回的信息了
			let subs = e.detail.subscribeDetails
			console.log(e)
			let subsStr = JSON.stringify(subs)
			if (subsStr.indexOf('accept') !== -1) {
				console.log('用户点击了允许，调用订阅接口')
				// 提取自定义属性
				const target = e.target;
				const id = target.dataset.id;
				const type = target.dataset.type;

				this.submitSubscribe({ id: id }, type);
				console.log(id, type, preview)
			} else if (subsStr.indexOf('reject') !== -1) {
				console.log('用户点击了取消')
			}

		},
		submitSubscribe(val, type) {
			this.subscribe_item = val
			this.subscribe_type = type
			Toast.loading({
				duration: 0,
				forbidClick: true,
				message: '',
			});
			const url = previewLive;
			let params = {
				meeting_id: this.meeting_id,
				type: type,
				time: this.pre_time,
				id: val.id

			};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					Toast.clear();
					if (res.code == 0) {
						common.toast('订阅成功', 1000)
						this.handleSubscribe(val.id)

						// this.showChooseTime = false;
						// this.$emit('subscribeTime', -1)
					}
					else {
						common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => { })
					}
				})
		},
		subscribeFail(e) {
			console.log('订阅失败')
		},
		cancelSubscribe(val, type) {
			Toast.loading({
				duration: 0,
				forbidClick: true,
				message: '',
			});
			const url = cancelPreviewLive;
			let params = {
				meeting_id: this.meeting_id,
				type: type,
				id: val.id
			};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					Toast.clear();
					if (res.code == 0) {
						val.is_preview = 0;
						// val.preview_count--
						common.toast('取消订阅成功', 1000)

					}
				})
		},
		onConfirm(val) {
			this.pre_time = val;
			this.showPicker = false
		}
	},
	destoryed() {
		clearInterval(this.timer)

	}
}
</script>
<style lang="scss" scoped>
a {
	color: #090909;
}



.live-schedule1 {
	// overflow: scroll;

	.timeTabs-wrap {
		overflow: hidden;
		width: 100%;
		background: #fff;

	}

	.fixed {
		position: fixed;
		top: 0px;
		z-index: 1000;
	}

	.timeTabs {
		padding: 0 12px;
		height: 60px;
		@include flex(row);
		align-items: center;
		overflow: auto;
		width: 100%;
		border-bottom: 1px solid #bfbfbf;

		.tab-item {
			font-size: 14px;
			color: #666;
			width: 70px;
			height: 30px;
			text-align: center;
			line-height: 30px;
			border: 1px solid #666;
			border-radius: 2px;
			margin-right: 15px;
		}

		.active {
			color: #fff;
			background: $color-main;
			border: 0px;
		}
	}

	.content {
		padding: 0px 12px;
		// overflow-y: scroll;
		height: 100%;

		.scheduleHead {
			// border-bottom: 1px solid #bfbfbf;

			.name-time {
				display: flex;

				.left-flex {
					width: 60%;

					.time2 {
						line-height: 22px;
						font-size: 12px;
						background: #FFE6E7;
						display: block;
						width: 110px;
						border-radius: 20px;
						text-align: center;
						color: #901D22;
						font-weight: 500;

					}
				}

				.right-flex {
					width: 40%;
				}

				// img{
				// 	margin-top:13px;
				// 	// height: 40px;
				// 	max-width: 100%;
				// 	display: block;
				// 	float:right;
				// }
			}
		}

		h3 {
			margin-top: 13px;
			font-size: 15px;
			color: #090909;
			letter-spacing: 0.53px;
			line-height: 28px;
			font-weight: normal;

			img {
				float: right;
				height: 20px;
				// transform: translate(0px,10px);
			}
		}

		.logo {
			margin: 10px 0;

			img {
				height: 40px;
				max-width: 100%;
			}
		}



		.attendee {
			margin: 10px 0;

			.expert {
				background-color: #fff;
				border-radius: 5px;
				padding: 10px 15px;
				margin-bottom: 20px;

				.host_t {
					color: #901D22;
					font-weight: 500;
				}

				// display: flex;
				img {
					width: 18px;
				}

				span {
					// margin-left: 5px;
					// margin-right: 5px;
					// color:$color-black;
					line-height: 22px;
					font-size: 12px;

				}



				p {
					flex: 1;
					text-align: justify;
					font-size: 12px;
					// color:#999;
					line-height: 22px;

				}

				.text-top {
					vertical-align: top;
					margin: 0 5px 0 2px;
				}

				// .names {

				// margin: 0 23px;
				// }
			}
		}

		.chapters {
			background-color: #fff;
			border-radius: 5px;
			scroll-behavior: smooth;
			-webkit-overflow-scrolling: touch;
		}


		.time-item-top {
			padding: 15px 10px;
			@include flex(row);
			justify-content: space-between;
			position: relative;
			scroll-margin-top: 340px;
			-webkit-scroll-margin-top: 340px;
			scroll-behavior: smooth;
		}


		.time {
			width: 40px;
			line-height: 18px;
			border-radius: 3px;
			color: #fff;
			font-weight: 500;
			background: linear-gradient(90deg, #B7B7B7 0%, #929292 100%);
			text-align: center;
			height: 18px;

			i {
				font-size: 15px;
				margin-right: 5px;
			}
		}

		.introduction {
			flex: 1;
			letter-spacing: .46px;
			margin-left: 15px;
			width: calc(100% - 190px);
			// margin-right: 65px;

			.title {
				color: $color-black;
				font-size: 13px;
				margin-bottom: 10px;
				text-align: justify;
			}

			.dot {
				width: 5px;
				height: 5px;
				background-color: #BFBFBF;
				border-radius: 10px;
				margin-right: 5px;
				display: inline-block;
			}

			.name {
				font-size: 12px;
				color: #666;
				display: flex;
				align-items: center;
				padding: 5px 0;
			}

			.des {
				font-size: 13px;
				word-break: break-all;
				text-align: justify;
			}

			span {
				margin-right: 2px;

			}
		}

		.status {
			>div {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;


			}



		}

		.icon_wrap {
			width: 66px;
			text-align: center;
			align-self: flex-end;
			height: 22px;

			img {
				width: 100%;
			}
		}

		.nopreview {
			color: #901D22 !important;
			border: 1px solid #901D22;
			padding: 0px 5px;
			min-width: 66px;
			height: 22px;
			line-height: 22px;
			text-align: center;
			font-size: 12px;
			border-radius: 30px;
			margin-left: 10px;
			flex-shrink: 0;
			position: relative;
		}

		.redbtn {
			background: #901D22;
			color: #fff !important;
			padding: 0px 5px;
			min-width: 66px;
			line-height: 22px;
			height: 22px;
			text-align: center;
			font-size: 12px;
			border-radius: 30px;
			margin-left: 10px;
			flex-shrink: 0;
		}

		.previewed {
			color: #fff !important;
			border: 1px solid #999;
			width: 66px;
			line-height: 22px;
			height: 22px;
			text-align: center;
			font-size: 12px;
			border-radius: 30px;
			background: #999;
			margin-left: 10px;
			flex-shrink: 0;

		}

		.wiki-info {
			width: calc(100% - 30px);
			display: flex;
			margin: 0 auto;
			padding: 15px 0px;
			align-items: center;
			border-top: 1px dashed #dadce0;
			position: relative;

			&>img {
				width: 34px;
				margin-right: 20px;
			}

			&>div {
				flex: 1;
				overflow: hidden;
				color: #204EA1;
				font-weight: 500;
				font-size: 14px;
			}
		}

		.launch-btn {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			z-index: 999;
		}

		.time-item:not(:last-child) {
			border-bottom: 1px solid #bfbfbf;
		}

		/*录播状态*/
		.norecord {

			.introduction .title {
				color: #666;
			}

			.introduction p {
				color: #666;
			}

		}

		/*没有开始状态*/
		.nostart {

			.introduction .title {
				color: #666;
			}

			.introduction p {
				color: #666;
			}

		}

		.change {
			.introduction .title {
				color: #204EA1;
			}

			.introduction p {
				color: #204EA1;
			}

		}

		/*录播状态*/
		.recorded {
			.time {
				background: linear-gradient(90deg, #4C82E3 0%, #204EA1 100%);
			}

			.introduction {
				color: #204EA1;

				span {
					// color: #3f3f3f;
					font-size: 11px;
				}
			}

			// .status{
			// 	background-image:url('../../../../assets/images/Meeting/Meeting_recorded.png');
			// }
		}

		/*正在直播状态*/
		.playing {
			background-color: #FFF0F0;

			.time {
				background: linear-gradient(90deg, #C33E47 0%, #901D22 100%);
			}

			.introduction .title {
				color: #000;
			}

			.introduction p {
				color: #901D22;
			}

			.status {
				color: #901D22;
			}
		}

		.one-line {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 100%;
			padding: 5px 0;
		}
	}
}

.van-popup {
	padding: 0 20px;
	text-align: center;
	color: #a21016;
	background-image: url('../../../../assets/images/cec2022/med_conference.png');
	background-size: 70% auto;
	background-position: 100% 40%;
	background-repeat: no-repeat;

	h2 {
		margin: 5px 0;
		padding: 0 10px;
		white-space: nowrap;
	}

	.yellowbd {
		border: 3px solid #ce9f70;
		border-radius: 15px;
	}

	button {
		margin: 10px 0;
		padding: 0px 40px;
		border: 3px solid #ce9f70;
		background: white;
		font-weight: 500;
		color: #a21016;
		border-radius: 20px;
		font-size: 16px;
		line-height: 36px;
	}

	/deep/.van-popup__close-icon--top-right {
		top: 0 !important;
		right: 0 !important;
	}
}

@media screen and (min-height:1100px) {
	.live-schedule1 .content .time-item {
		scroll-margin-top: 450px !important;
		-webkit-scroll-margin-top: 450px !important;

	}
}

.max-page-height {
	max-height: 60vh;
}

.avatar {
	width: 24px !important;
	height: 24px !important;
	border-radius: 50%;
	object-fit: cover;
	margin-right: 4px;
	vertical-align: middle;

}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Schedule.vue